import { render, staticRenderFns } from "./ShowCategory.vue?vue&type=template&id=06a596c6&scoped=true"
import script from "./ShowCategory.vue?vue&type=script&lang=js"
export * from "./ShowCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a596c6",
  null
  
)

export default component.exports